(function () {
    'use strict';

    function underwritingNote(workflowStateService) {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/underwritingNote.html',
            scope: {
                path: '=',
                noteData: '=',
                noteIndex: '=',
                onRemove: '&',
                notes: '='
            },
            link: function (scope, element, attrs) {
                scope.mode = 'display';
                scope.canSave = false;

                if (!scope.noteData.UpdatedByUserName) {
                    scope.mode = 'edit';
                }

                function resetState() {
                    scope.mode = 'display';
                }

                scope.removeNote = function () {
                    workflowStateService.removeUnderwritingNote(scope.noteData.NoteId);
                    scope.onRemove({ noteId: scope.noteData.NoteId });
                }

                scope.editNote = function () {
                    scope.mode = 'edit';
                    scope.originalNoteText = scope.noteData.Note;
                }

                scope.saveNote = function () {
                    scope.noteData.IsNew = false;
                    workflowStateService.saveUnderwritingNote(scope.noteData);
                    if (!scope.noteData.UpdatedByUserName) {
                        scope.onAdd();
                    }
                    resetState();
                }

                scope.cancelEditNote = function () {
                    if (!scope.noteData.UpdatedByUserName) {
                        scope.noteData.IsDeleted = true;
                    }
                    else {
                        scope.noteData.Note = scope.originalNoteText;
                    }
                    resetState();
                }
            }
        };
    }

    underwritingNote.$inject = ['workflowStateService'];

    angular.module('ecap.workflow').directive('underwritingNote', underwritingNote);
})();

